import { EReviewsActionTypes } from '../../actions/reviews';
import { TReduxActions, IReviews } from '../../types/redux';
import { mapLikeAndDislikeReaction } from '../../mappers/LikeAndDislikeReaction';

export const defaultReviewsState: IReviews = {
  allIds: [],
  byId: {},
  hasMore: false,
  page: 0,
};

export function reviewsReducer(state: IReviews = defaultReviewsState, action: TReduxActions) {
  switch (action.type) {
    case EReviewsActionTypes.SetReviews: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case EReviewsActionTypes.SetAnswersVisibility: {
      const { reviewId, state: areAnswersOpened } = action.payload;

      return {
        ...state,
        byId: {
          ...state.byId,
          [reviewId]: {
            ...state.byId[reviewId],
            areAnswersOpened,
          },
        },
      };
    }

    case EReviewsActionTypes.AddAnswersToReview: {
      const { reviewId, answerIds, hasMore, answersPage } = action.payload;

      const ids = new Set(state.byId[reviewId].answers);
      answerIds.forEach(id => ids.add(id));

      return {
        ...state,
        byId: {
          ...state.byId,
          [reviewId]: {
            ...state.byId[reviewId],
            answers: [...ids],
            hasMoreAnswers: hasMore,
            answersPage,
          },
        },
      };
    }

    case EReviewsActionTypes.SetAnswersPage: {
      const { reviewId, page } = action.payload;

      return {
        ...state,
        byId: {
          ...state.byId,
          [reviewId]: {
            ...state.byId[reviewId],
            answersPage: page,
          },
        },
      };
    }

    case EReviewsActionTypes.SetReviewReaction: {
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.reviewId]: {
            ...state.byId[action.payload.reviewId],
            like: mapLikeAndDislikeReaction({
              currentState: state.byId[action.payload.reviewId].like,
              nextState: action.payload.type,
            }),
          },
        },
      };
    }

    case EReviewsActionTypes.SetReviewsPage: {
      return {
        ...state,
        allIds: [...state.allIds, ...action.payload.allIds],
        byId: {
          ...state.byId,
          ...action.payload.byId,
        },
        hasMore: action.payload.hasMore,
        page: action.payload.page,
      };
    }

    default:
      return state;
  }
}
